export var appCustomCssRelativePath = "/snippets/css";
export var createAppCustomCssApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(appCustomCssRelativePath);
    return {
        get: function () { return http.get("".concat(apiUrl)); },
        update: function (dto) { return http.put("".concat(apiUrl), dto.data); }
    };
};
//# sourceMappingURL=index.js.map